export enum casesIdTypes { all, inprocess, scientist, finalized, pending, cancelled, hold, clientCases, overdue }
export enum ordersIdTypes { all, pending, received, completed = 4, rejected, awaitingResults, deleted = 10, covidOrder, exceptions, hold }
export enum pcrPgxIdTypes { all, received, hold, inprocess, finalized, signOut, cancelled, rejected, overdue, summary }
export enum patientsIdTypes { active, inActive }
export enum clients { active, inActive, physicians }
export enum resultsIdTypes { pendingFax, faxSent, batchPrint, interfaceResults, resultsSent, chargesQ, chargesSent, allCharges, failedCharges }
export enum workBenchDocument { allDocument, patient, case, insurance }
export enum workBenchInventories { supplies, expiredSupplies, equipments, plates, storage, reagentTypes, serviceDue }
export enum workBenchToxQ { workList, runInProgress, runsCompleted, qcByRun, qcControls, qcNotifications }
export enum workBenchClinicalQ { cases, qc, qcNotifications, referenced, criticalsQ }
export enum workBenchWorklists { worklist, runInProgress, runsCompleted, runsFinalized, runsRepeated, qcData }
export enum workBenchTestQ { pcr, pgx }
export enum accessionShipping { allShipments, create, preparing, ready, shipped, received }
export enum accessionReminder { all, holdQueue, newDrugs }
export enum accessionSendOut { sendOutCases, sendOut, sendOutlabs }
export enum ClientServicesOpenCases { toxicology, clinical, molecular }
export enum ClientServicesBillingQ { toxQ, clinical, holdQ, pgxHolds, faxesReceived, completedAuth, preAuthReq, preAuthFaxed, insurancesQ, pcrQ, pendingQ, pendingInsuranceQ }
export enum ClientServicesInventory { requests, clientInventory, belowThreshold, approved, shipSupplies }
export enum ClientServicesCovidReports { positive, pending, reported }
export enum LabAdminTox { compounds, drugs, testCodes, validityCodes, profiles, archivedProfiles }
export enum LabAdminClinical { chemicalTests, testProfile, archivedProfiles, containerTypes, customProfiles }
export enum EnumLabAdminMolecular { testLibraries, archivedTests, testTypes, testProfiles, archivedProfiles, worklist, protocols, worklistsTypes, rejectCriteria, antibiotics }
export enum LabAdminPGX { allele, metabolizer, drug, drugs }
export enum EnumLabAdminLibraries { macros, cancelReject, amendment, orderQuestionnaire }
export enum SettingsLabSetup { labInfo, lab, validation }
export enum LabAdminBilling { icdCodes, cptCodes, billingStatuses }
export enum BatchProcess { toxLabels, pcrLabels, batchPrintFax }
export enum CaseReports { cases, pcrAndPGX }

export const MenuList: any = [
  {
    name: 'Accession',
    url: '/accession',
    icon: 'fas fa-universal-access',
    child: [
      {
        name: 'Cases', url: '/accession/cases', action: 'toxicology', otherActionOne: 'clinical' , icon: 'fas fa-clipboard',
        filterOptions: [
          { id: casesIdTypes.all, name: 'All Cases' },
          { id: casesIdTypes.inprocess, name: 'Accessioned' },
          { id: casesIdTypes.pending, name: 'Pending' },
          { id: casesIdTypes.hold, name: 'Hold' },
          { id: casesIdTypes.finalized, name: 'Finalized' },
          { id: casesIdTypes.cancelled, name: 'Cancelled' },
          { id: casesIdTypes.overdue, name: 'Overdue' },
        ]
      },      
      {
        name: 'Orders', url: '/accession/orders', icon: 'fas fa-calendar-alt',
        filterOptions: [
          { id: ordersIdTypes.all, name: 'All Orders' },
          { id: ordersIdTypes.pending, name: 'Pending' },
          { id: ordersIdTypes.received, name: 'Received' },
          { id: ordersIdTypes.awaitingResults, name: 'Awaiting Results' },
          { id: ordersIdTypes.completed, name: 'Completed' },
          { id: ordersIdTypes.rejected, name: 'Rejected' },
          { id: ordersIdTypes.deleted, name: 'Deleted' },
          { id: ordersIdTypes.covidOrder, name: 'Covid Orders' },
          { id: ordersIdTypes.exceptions, name: 'Exceptions' },
        ]
      },
      { name: 'Receive Specimens', url: '/accession/receive-specimens', icon: 'fas fa-user-astronaut', filterOptions: [] },
      { name: 'New Order', url: '/accession/orders/order/' + 0 + '/' + 0 + '/' + 0 + '/' + false + '/new-order', icon: 'fas fa-cart-plus', filterOptions: [],action: 'addcase' },
     // { name: 'Quick Order', url: '/accession/orders/order/' + 0 + '/' + 0 + '/' + 0 + '/quick-order', icon: 'fas fa-shopping-cart', filterOptions: [],action: 'addcase' },
      {
        name: 'Patients', url: '/accession/patients', icon: 'fas fa-users',
        filterOptions: [
          { id: patientsIdTypes.active, name: 'Active' },
          { id: patientsIdTypes.inActive, name: 'Inactive' },
        ]
      },
      {
        name: 'Documents', url: '/accession/documents', icon: 'fas fa-file-alt',
        filterOptions: [
          { id: workBenchDocument.allDocument, name: 'All Documents' },
          { id: workBenchDocument.patient, name: 'Patient' },
          { id: workBenchDocument.case, name: 'Case Documents' },
          { id: workBenchDocument.insurance, name: 'Insurances' },
        ]
      },
      {
        name: 'Send Outs', url: '/accession/send-out', icon: 'fas fa-share-square',
        filterOptions: [
          { id: accessionSendOut.sendOutCases, name: 'Send-Out Cases' },
          { id: accessionSendOut.sendOut, name: 'Received' },
          { id: accessionSendOut.sendOutlabs, name: 'Send-Out Labs' },
        ]
      },
      {
        name: 'Reminders', url: '/accession/reminder', icon: 'fas fa-stopwatch' , action: 'notifications',
        filterOptions: [
          { id: accessionReminder.all, name: 'All' },
          { id: accessionReminder.holdQueue, name: 'Hold Queue' },
          { id: accessionReminder.newDrugs, name: 'New Drugs' },
        ]
      },
      {
        name: 'Shipping', url: '/accession/shipping', icon: 'fas fa-shipping-fast', action: 'shipping',
        filterOptions: [
          { id: accessionShipping.shipped, name: 'Shipped' },
          { id: accessionShipping.received, name: 'Received' },
        ]
      },
      {
        name: 'PCR/PGX', url: '/accession/pcr-pgx', icon: 'fas fa-tablet', action: 'molecular', filterOptions: [
          { id: pcrPgxIdTypes.all, name: 'All Cases' },
          { id: pcrPgxIdTypes.received, name: 'Received' },
          { id: pcrPgxIdTypes.inprocess, name: 'In Process' },
          { id: pcrPgxIdTypes.finalized, name: 'Finalized' },
          { id: pcrPgxIdTypes.signOut, name: 'Signed Out' },
          { id: pcrPgxIdTypes.hold, name: 'On Hold' },
          { id: pcrPgxIdTypes.cancelled, name: 'Cancelled' },
          { id: pcrPgxIdTypes.rejected, name: 'Rejected' },
          { id: pcrPgxIdTypes.overdue, name: 'Overdue' },
          { id: pcrPgxIdTypes.summary, name: 'Summary' }
        ]
      },
    ]
  },
  {
    name: 'Workbench',
    url: '/work-bench',
    icon: 'fas fa-briefcase',
    // permission: 'workbench',
    child: [
      {
        name: 'Patients', url: '/work-bench/patients', icon: 'fas fa-users',
        filterOptions: [
          { id: patientsIdTypes.active, name: 'Active' },
          { id: patientsIdTypes.inActive, name: 'Inactive' },
        ]
      },
      {
        name: 'Tox Q', url: '/work-bench/tox-q', icon: 'fas fa-warehouse', action: 'toxicology',
        filterOptions: [
          { id: workBenchToxQ.workList, name: 'WorkList' },
          { id: workBenchToxQ.runInProgress, name: 'Run In Progress' },
          { id: workBenchToxQ.runsCompleted, name: 'Runs Completed' },
          { id: workBenchToxQ.qcByRun, name: 'QC By Run' },
          { id: workBenchToxQ.qcControls, name: 'QC Controls' },
          { id: workBenchToxQ.qcNotifications, name: 'QC Notifications' },
        ]
      },
      {
        name: 'Clinical Q', url: '/work-bench/clinical-q/0', icon: 'fas fa-database', action: 'clinical',
        filterOptions: [
          { id: workBenchClinicalQ.cases, name: 'Cases' },
          { id: workBenchClinicalQ.referenced, name: 'Referenced' },
          { id: workBenchClinicalQ.criticalsQ, name: 'Criticals Q' },
          { id: workBenchClinicalQ.qc, name: 'QC' },
          { id: workBenchClinicalQ.qcNotifications, name: 'QC Notifications' },
        ]
      },
      { name: 'PCR Q', url: '/work-bench/pcr-q', icon: 'fas fa-tablet', action: 'molecularpcr', filterOptions: [] },
      {
        name: 'Worklists', url: '/work-bench/worklists', icon: 'fas fa-building', action: 'molecularpcr',
        filterOptions: [
          { id: workBenchWorklists.worklist, name: 'Worklist' },
          { id: workBenchWorklists.runInProgress, name: 'Run In Progress' },
          { id: workBenchWorklists.runsCompleted, name: 'Runs Completed' },
          { id: workBenchWorklists.runsFinalized, name: 'Runs Finalized' },
          { id: workBenchWorklists.runsRepeated, name: 'Runs Repeated' },
          { id: workBenchWorklists.qcData, name: 'QC Data' },
        ]
      },
      {
        name: 'Inventories', url: '/work-bench/inventories', icon: 'fas fa-window-maximize',
        filterOptions: [
          { id: workBenchInventories.supplies, name: 'Supplies' },
          { id: workBenchInventories.expiredSupplies, name: 'Expired Supplies' },
          { id: workBenchInventories.equipments, name: 'Equipments' },
          { id: workBenchInventories.plates, name: 'Plates' },
          { id: workBenchInventories.storage, name: 'Storage' },
          { id: workBenchInventories.reagentTypes, name: 'Supply Types' },
          { id: workBenchInventories.serviceDue, name: 'Service Due' },
        ]
      },
      {
        name: 'Cases (PCR / PGX)',  url: '/work-bench/pcr-pgx', icon: 'fas fa-tablet', action: 'molecular', filterOptions: [
          { id: pcrPgxIdTypes.all, name: 'All Cases' },
          { id: pcrPgxIdTypes.received, name: 'Received' },
          { id: pcrPgxIdTypes.inprocess, name: 'In Process' },
          { id: pcrPgxIdTypes.finalized, name: 'Finalized' },
          { id: pcrPgxIdTypes.signOut, name: 'Signed Out' },
          { id: pcrPgxIdTypes.hold, name: 'On Hold' },
          { id: pcrPgxIdTypes.cancelled, name: 'Cancelled' },
          { id: pcrPgxIdTypes.rejected, name: 'Rejected' },
          { id: pcrPgxIdTypes.overdue, name: 'Overdue' },
          { id: pcrPgxIdTypes.summary, name: 'Summary' },
        ]
      },
      {
        name: 'Tests Q', url: '/work-bench/test-q', icon: 'fas fa-map',  action: 'molecularpcr', filterOptions: [
        { id: workBenchTestQ.pcr, name: 'PCR' },
        { id: workBenchTestQ.pgx, name: 'PGX' },
        ]
        },
    ]
  },

  // {
  //   name: 'Analytics',
  //   url: '/analytics',
  //   icon: 'fas fa-chart-bar',
  //   child: [
  //     { name: 'Revenue', url: '/analytics/revenue', icon: 'fas fa-retweet' },
  //     { name: 'Specimen', url: '/analytics/specimen', icon: 'fas fa-user-astronaut' },
  //     { name: 'Test Analytics', url: '/analytics/test-analytics', icon: 'fas fa-cubes' },
  //   ]
  // },
 {
    name: 'Reports',
    url: '/client-services/reports',
    icon: 'fas fa-file-contract',
    child: [
      { name: 'Case Reports', url: '/client-services/reports', icon: 'fas fa-file-alt',
      filterOptions: [
        { id: CaseReports.cases, name: 'Cases' },
        { id: CaseReports.pcrAndPGX, name: 'PCR / PGX' },
      ]
     },
      { name: 'Billing Report', url: '/client-services/billing-report', icon: 'fas fa-file-invoice-dollar' },
      { name: 'Confirmation Report', url: '/client-services/confirmation-report', icon: 'fas fa-file-invoice' },
      { name: 'CPT Counts', url: '/client-services/cpt-counts', icon: 'far fa-id-card' },
      { name: 'Tests Reports', url: '/client-services/billing-admin-test-report', icon: 'fas fa-file-alt' },
      { name: 'Invoices Reports', url: '/client-services/billing-admin-invoice-report', icon: 'fas fa-file-alt' },
      { name: 'Analytics', url: '/analytics/specimen/1', icon: 'fas fa-chart-bar', action: 'analytics' },
    ]
  },
  {
    name: 'Settings',
    url: '/lab-admin/lab-setup',
    icon: 'fas fa-cogs',
    child: [
      {
        name: 'Lab Setup', url: '/lab-admin/lab-setup', icon: 'fas fa-vials',
        filterOptions: [
          { id: SettingsLabSetup.labInfo, name: 'Lab Info' },
          { id: SettingsLabSetup.lab, name: 'Lab Notifications' },
          { id: SettingsLabSetup.validation, name: 'Validation' },
        ]
      },
      { name: 'Users', url: '/lab-admin/users', icon: 'fas fa-users', filterOptions: [] },
      { name: 'Roles', url: '/lab-admin/roles', icon: 'fas fa-user-tag', filterOptions: [] },
      { name: 'Permissions', url: '/lab-admin/permissions', icon: 'fas fa-user-cog', filterOptions: [] },
    ]
  },
  {
    name: 'Lab Admin',
    url: '/lab-admin',
    icon: 'fas fa-vials',
    child: [
      {
        name: 'Tox', url: '/lab-admin/tox', icon: 'fas fa-suitcase', action: 'toxicology',
        filterOptions: [
          { id: LabAdminTox.compounds, name: 'Compounds' },
          { id: LabAdminTox.drugs, name: 'Drugs' },
          { id: LabAdminTox.testCodes, name: 'Test Codes' },
          { id: LabAdminTox.validityCodes, name: 'Validity Codes' },
          { id: LabAdminTox.profiles, name: 'Profiles' },
          { id: LabAdminTox.archivedProfiles, name: 'Archived Profiles' },
        ]
      },
      {
        name: 'Clinical', url: '/lab-admin/clinical', icon: 'fas fa-notes-medical', action: 'clinical',
        filterOptions: [
          { id: LabAdminClinical.chemicalTests, name: 'Chemical Tests' },
          { id: LabAdminClinical.testProfile, name: 'Test Profiles' },
          { id: LabAdminClinical.archivedProfiles, name: 'Archived Profiles' },
          { id: LabAdminClinical.containerTypes, name: 'Container Types' },
          { id: LabAdminClinical.customProfiles, name: 'Custom Profiles' },
        ]
      },
      {
        name: 'Molecular', url: '/lab-admin/molecular', icon: 'fas fa-x-ray', action: 'molecularpcr',
        filterOptions: [
          { id: EnumLabAdminMolecular.testLibraries, name: 'Test Libraries' },
          { id: EnumLabAdminMolecular.archivedTests, name: 'Archived Tests' },
          { id: EnumLabAdminMolecular.testTypes, name: 'Test Types' },
          { id: EnumLabAdminMolecular.testProfiles, name: 'Test Profiles' },
          { id: EnumLabAdminMolecular.archivedProfiles, name: 'Archived Profiles' },
          { id: EnumLabAdminMolecular.worklist, name: 'Worklist' },
          { id: EnumLabAdminMolecular.protocols, name: 'Protocols' },
          { id: EnumLabAdminMolecular.worklistsTypes, name: 'Worklists Types' },
          { id: EnumLabAdminMolecular.rejectCriteria, name: 'Reject Criteria' },
          { id: EnumLabAdminMolecular.antibiotics, name: 'Antibiotics' },
        ]
      },
      {
        name: 'PGX', url: '/lab-admin/pgx', icon: 'fas fa-capsules', action: 'pgx',
        filterOptions: [
          { id: LabAdminPGX.allele, name: 'Allele' },
          { id: LabAdminPGX.metabolizer, name: 'Metabolizer' },
          { id: LabAdminPGX.drug, name: 'Drug' },
          { id: LabAdminPGX.drugs, name: 'Drugs' },
        ]
      },
      {
        name: 'Libraries', url: '/lab-admin/libraries', icon: 'fas fa-book-open',
        filterOptions: [
          { id: EnumLabAdminLibraries.macros, name: 'Macros' },
          { id: EnumLabAdminLibraries.cancelReject, name: 'Cancel / Reject' },
          { id: EnumLabAdminLibraries.amendment, name: 'Amendment Reasons' },
         // { id: EnumLabAdminLibraries.orderQuestionnaire, name: 'Order Questionnaire'}
        ]
      },
      { name: 'Pathologists', url: '/lab-admin/pathologists', icon: 'fab fa-patreon' },
      {
        name: 'Inventory Requests', url: '/client-services/client-services-inventory', icon: 'fas fa-boxes',
        filterOptions: [
          { id: ClientServicesInventory.requests, name: 'Requests' },
          { id: ClientServicesInventory.clientInventory, name: 'Client Inventory' },
          { id: ClientServicesInventory.belowThreshold, name: 'Below Threshold' },
          { id: ClientServicesInventory.approved, name: 'Approved' },
          { id: ClientServicesInventory.shipSupplies, name: 'Ship Supplies' },
        ]
      },
    ]
  },
  {
    name: 'Data Review',
    url: '/data-entry-review',
    icon: 'fas fa-database',
    child: [
      {
        name: 'Orders Review', url: '/data-entry-review/orders-data-review/10/false', icon: 'fas fa-table',
        filterOptions: [
          { id: ClientServicesBillingQ.pendingQ, name: 'Orders Review' },
          { id: ClientServicesBillingQ.pcrQ, name: 'Cases Review' },
          { id: ClientServicesBillingQ.insurancesQ, name: 'Insurances Review' },
        ]
      },
      {
        name: 'Cases Review', url: '/data-entry-review/data-deficiency-review/9/false', icon: 'fas fa-server',
        filterOptions: [
          { id: ClientServicesBillingQ.pendingQ, name: 'Orders Review' },
          { id: ClientServicesBillingQ.pcrQ, name: 'Cases Review' },
          { id: ClientServicesBillingQ.insurancesQ, name: 'Insurances Review' },
        ]
      },
      {
        name: 'Insurances Review', url: '/data-entry-review/insurance-list-review/8/false', icon: 'fas fa-chalkboard-teacher',
        filterOptions: [
          { id: ClientServicesBillingQ.pendingQ, name: 'Orders Review' },
          { id: ClientServicesBillingQ.pcrQ, name: 'Cases Review' },
          { id: ClientServicesBillingQ.insurancesQ, name: 'Insurances Review' },
        ]
      },
    ]
  },
  {
    name: 'Client Services',
    url: '/client-services/open-cases/openCases',
    icon: 'fas fa-briefcase-medical',
    child: [
      {
        name: 'Open Cases', url: '/client-services/open-cases/openCases/0', icon: 'fas fa-briefcase-medical',
        filterOptions: [
          { id: ClientServicesOpenCases.toxicology, name: 'Toxicology',action: "toxicology" },
          { id: ClientServicesOpenCases.clinical, name: 'Clinical' ,action: "clinical"},
          { id: ClientServicesOpenCases.molecular, name: 'Molecular',action: "molecularpcr" },
        ]
      },
      {
        name: 'Cases', url: '/client-services/open-cases/cases/0', icon: 'fas fa-clipboard',
        filterOptions: [
          { id: ClientServicesOpenCases.toxicology, name: 'Toxicology',action: "toxicology" },
          { id: ClientServicesOpenCases.clinical, name: 'Clinical',action: "clinical" },
          { id: ClientServicesOpenCases.molecular, name: 'Molecular',action: "molecularpcr" },
        ]
      },
      {
        name: 'Patients', url: '/client-services/patients', icon: 'fas fa-users',
        filterOptions: [
          { id: patientsIdTypes.active, name: 'Active' },
          { id: patientsIdTypes.inActive, name: 'Inactive' },
        ]
      },
      {
        name: 'Reference Q', url: '/work-bench/clinical-q/3', icon: 'fas fa-database', action: 'clinical',
        filterOptions: [
          { id: workBenchClinicalQ.cases, name: 'Cases' },
          { id: workBenchClinicalQ.referenced, name: 'Referenced' },
          { id: workBenchClinicalQ.criticalsQ, name: 'Criticals Q' },
          { id: workBenchClinicalQ.qc, name: 'QC' },
          { id: workBenchClinicalQ.qcNotifications, name: 'QC Notifications' },
        ]
      },
      {
        name: 'Reminders', url: '/accession/reminderClientServices', icon: 'fas fa-stopwatch', action: 'notifications',
        filterOptions: [
          { id: accessionReminder.all, name: 'All' },
          { id: accessionReminder.holdQueue, name: 'Hold Queue' },
          { id: accessionReminder.newDrugs, name: 'New Drugs' },
        ]
      },
      {
        name: 'Interface Results', url: '/interfaces/all-results/3/interfaces-result', icon: 'fas fa-folder-open',
        filterOptions: [
          { id: resultsIdTypes.interfaceResults, name: 'Interface Results' },
          { id: resultsIdTypes.resultsSent, name: 'Sent Results' },
        ]
      },
      {
        name: 'Interface Charges', url: '/interfaces/all-charges/6/interface-charges', icon: 'fas fa-file-invoice-dollar',
        filterOptions: [
         // { id: resultsIdTypes.allCharges, name: 'Interface Charges' },
          { id: resultsIdTypes.chargesSent, name: 'Sent Charges' },
          { id: resultsIdTypes.chargesQ, name: 'Unsent Charges' },
         // { id: resultsIdTypes.failedCharges, name: 'Failed Charges' },
        ]
      },
      {
        name: 'Faxes', url: '/faxes/pending-faxes/0/faxes', icon: 'fas fa-fax',
        filterOptions: [
          { id: resultsIdTypes.pendingFax, name: 'Pending Faxes' },
          { id: resultsIdTypes.faxSent, name: 'Sent' },
          { id: resultsIdTypes.batchPrint, name: 'Batch Print / fax' },
        ]
      },
      {
        name: 'COVID Regulatory', url: '/regulatory/positive/0', icon: 'fas fa-briefcase-medical',
        filterOptions: [
          { id: ClientServicesCovidReports.positive, name: 'Positive' },
          { id: ClientServicesCovidReports.pending, name: 'Pending' },
          { id: ClientServicesCovidReports.reported, name: 'Reported' },
        ]
      },
      {
        name: 'Reports',
        url: '/client-services/reports',
        icon: 'fas fa-file-contract',
        child: [
          { name: 'Case Reports', url: '/client-services/reports', icon: 'fas fa-file-alt',
          filterOptions: [
            { id: CaseReports.cases, name: 'Cases' },
            { id: CaseReports.pcrAndPGX, name: 'PCR / PGX' },
          ]
          }
        
        ]
         },
          
      {
        name: 'Client Inventory', url: '/client-services/client-services-inventory', icon: 'fas fa-boxes',
        filterOptions: [
          { id: ClientServicesInventory.requests, name: 'Requests' },
          { id: ClientServicesInventory.clientInventory, name: 'Client Inventory' },
          { id: ClientServicesInventory.belowThreshold, name: 'Below Threshold' },
          { id: ClientServicesInventory.approved, name: 'Approved' },
          { id: ClientServicesInventory.shipSupplies, name: 'Ship Supplies' },
        ]
      },
      {
        name: 'Batch Jobs', url: '/batch-processes/print-fax/2', icon: 'fas fa-boxes',
        filterOptions: [
          { id: BatchProcess.toxLabels, name: 'Tox Labels' },
          { id: BatchProcess.pcrLabels, name: 'PCR Labels' },
          { id: BatchProcess.batchPrintFax, name: 'Batch Print/Fax' },
        ]
      },
      {
        name: 'Download Reports', url: '/client-services/download-cases-report', icon: 'fas fa-boxes',  action: 'viewdownloadreports'       
      },
    ]
  },
  {
    name: 'Client Admin',
    url: '/client-admin',
    icon: 'fas fa-user-tie',
    child: [
      {
        name: 'Clients', url: '/client-admin/active/0', icon: 'fas fa-user-plus',
        filterOptions: [
          { id: clients.active, name: 'Active Clients' },
          { id: clients.inActive, name: 'Inactive Clients' },
          { id: clients.physicians, name: 'Physicians' },
        ],
      },
      { name: 'Sales Rep', url: '/lab-admin/sales-rep', icon: 'fas fa-universal-access' },
    ]
  },
  // {
  //   name: 'Interfaces',
  //   url: '/interfaces',
  //   icon: 'fas fa-map',
  //   child: [
  //     {
  //       name: 'All Results', url: '/interfaces/all-results/3', icon: 'fas fa-folder-open',
  //       filterOptions: [
  //         { id: resultsIdTypes.interfaceResults, name: 'All Results' },
  //         { id: resultsIdTypes.resultsSent, name: 'Sent Results' },
  //       ]
  //     },
  //     {
  //       name: 'Sent Results', url: '/interfaces/sent/4', icon: 'fas fa-paper-plane',
  //       filterOptions: [
  //         { id: resultsIdTypes.interfaceResults, name: 'All Results' },
  //         { id: resultsIdTypes.resultsSent, name: 'Sent Results' },
  //       ]
  //     },
  //     {
  //       name: 'All Charges', url: '/interfaces/all-charges/7', icon: 'fas fa-file-invoice-dollar',
  //       filterOptions: [
  //         { id: resultsIdTypes.allCharges, name: 'All Charges' },
  //         { id: resultsIdTypes.chargesSent, name: 'Sent Charges' },
  //         { id: resultsIdTypes.chargesQ, name: 'Unsent Charges' },
  //         { id: resultsIdTypes.failedCharges, name: 'Failed Charges' },
  //       ]
  //     },
  //     {
  //       name: 'Sent Charges', url: '/interfaces/sent-charges/6', icon: 'fas fa-money-bill',
  //       filterOptions: [
  //         { id: resultsIdTypes.allCharges, name: 'All Charges' },
  //         { id: resultsIdTypes.chargesSent, name: 'Sent Charges' },
  //         { id: resultsIdTypes.chargesQ, name: 'Unsent Charges' },
  //         { id: resultsIdTypes.failedCharges, name: 'Failed Charges' },
  //       ]
  //     },
  //     {
  //       name: 'Unsent Charges', url: '/interfaces/unsent-charges/5', icon: 'fas fa-money-bill-wave-alt',
  //       filterOptions: [
  //         { id: resultsIdTypes.allCharges, name: 'All Charges' },
  //         { id: resultsIdTypes.chargesSent, name: 'Sent Charges' },
  //         { id: resultsIdTypes.chargesQ, name: 'Unsent Charges' },
  //         { id: resultsIdTypes.failedCharges, name: 'Failed Charges' },
  //       ]
  //     },
  //     {
  //       name: 'Failed Charges', url: '/interfaces/failed-charges/8', icon: 'fas fa-file-excel',
  //       filterOptions: [
  //         { id: resultsIdTypes.allCharges, name: 'All Charges' },
  //         { id: resultsIdTypes.chargesSent, name: 'Sent Charges' },
  //         { id: resultsIdTypes.chargesQ, name: 'Unsent Charges' },
  //         { id: resultsIdTypes.failedCharges, name: 'Failed Charges' },
  //       ]
  //     },
  //   ]
  // },
  {
    name: 'Billing Admin',
    url: '/billing-admin',
    icon: 'fas fa-money-check-alt',
    child: [
      {
        name: 'ICD/CPT Codes', url: '/billing-admin/icd-codes/0', icon: 'fas fa-sitemap',action:'billing',
        filterOptions: [
          { id: LabAdminBilling.icdCodes, name: 'ICD Codes' },
          { id: LabAdminBilling.cptCodes, name: 'CPT Codes' },
        ]
      },
      {
        name: 'Billing Statuses', url: '/billing-admin/icd-codes/billing-status', icon: 'fas fa-sitemap',action:'billing',
      },
      { name: 'Insurance Companies', url: '/billing-admin/insurance-companies', icon: 'fas fa-building' },
       { name: 'CPT Counts', url: '/billing-admin/cpt-counts', icon: 'far fa-id-card' },
      {
        name: 'Billing Review', url: '/miscellaneous/billing-q/0/true', icon: 'fas fa-chalkboard-teacher',
        filterOptions: [
          { id: ClientServicesBillingQ.toxQ, name: 'Tox Q',action: "toxicology" },
          { id: ClientServicesBillingQ.clinical, name: 'Clinical',action: "clinical" },
          { id: ClientServicesBillingQ.holdQ, name: 'Hold Q' },
          { id: ClientServicesBillingQ.pgxHolds, name: 'PGX Holds' },
          { id: ClientServicesBillingQ.faxesReceived, name: 'Faxes Received' },
          { id: ClientServicesBillingQ.completedAuth, name: 'Complete Auth' },
          { id: ClientServicesBillingQ.preAuthReq, name: 'Pre-Auth Req' },
          { id: ClientServicesBillingQ.preAuthFaxed, name: 'Pre-Auth Faxed' },
          { id: ClientServicesBillingQ.insurancesQ, name: 'Insurances Q' },
          // { id: ClientServicesBillingQ.pcrQ, name: 'PCR Q' },
          // { id: ClientServicesBillingQ.pendingQ, name: 'Pending Q' },
          // { id: ClientServicesBillingQ.pendingInsuranceQ, name: 'Pending Insurance Q' },
        ]
      },
    ]
  },
  // {
  //   name: 'Batch Processes',
  //   url: '/batch-process',
  //   icon: 'fas fa-briefcase-medical',
  //   child: [
  //     {
  //       name: 'Tox Labels', url: '/batch-processes/print-tox/0', icon: 'fas fa-plus'
  //     },
  //     {
  //       name: 'PCR Labels', url: '/batch-processes/print-pcr/1', icon: 'fas fa-stop-circle'
  //     },
  //     {
  //       name: 'Batch Print/ Fax', url: '/batch-processes/print-fax/2', icon: 'fas fa-notes-medical'
  //     }
  //   ]
  // },
  {
    name: 'Miscellaneous',
    url: '/miscellaneous',
    icon: 'fab fa-bandcamp',
    child: [
      // {
      //   name: 'Reports', url: '/miscellaneous/results/0', icon: 'fas fa-file-invoice-dollar',
      //   filterOptions: [
      //     { id: resultsIdTypes.pendingFax, name: 'Pending Fax' },
      //     { id: resultsIdTypes.faxSent, name: 'Fax Sent' },
      //     { id: resultsIdTypes.batchPrint, name: 'Batch Print / fax' },
      //     { id: resultsIdTypes.interfaceResults, name: 'Interface Results' },
      //     { id: resultsIdTypes.resultsSent, name: 'Results Sent' },
      //     { id: resultsIdTypes.chargesQ, name: 'Charges Q' },
      //     { id: resultsIdTypes.chargesSent, name: 'Charges Sent' },
      //     { id: resultsIdTypes.allCharges, name: 'All Charges' },
      //     { id: resultsIdTypes.failedCharges, name: 'Failed Charges' },
      //   ]
      // },
      // {
      //   name: 'Billing', url: '/miscellaneous/billing/0', icon: 'fas fa-sitemap',
      //   filterOptions: [
      //     { id: LabAdminBilling.icdCodes, name: 'ICD Codes' },
      //     { id: LabAdminBilling.cptCodes, name: 'CPT Codes' },
      //     { id: LabAdminBilling.billingStatuses, name: 'Billing Statuses' },
      //   ]
      // },
      // { name: 'Referenced', url: '/work-bench/referenced/99', icon: 'fas fa-street-view', filterOptions: [] },
      {
        name: 'Tests Q', url: '/work-bench/test-q', icon: 'fas fa-map', filterOptions: [
          { id: workBenchTestQ.pcr, name: 'PCR' },
          { id: workBenchTestQ.pgx, name: 'PGX' },
        ]
      },
      { name: 'Billing Admin Report', url: '/billing-admin/billing-admin-report', icon: 'fas fa-newspaper' },
      { name: 'Invoices', url: '/billing-admin/billing-admin-invoices', icon: 'fas fa-file-invoice' },
      { name: 'Notifications', url: '/billing-admin/billing-admin-notifications', icon: 'fas fa-bell' },
      { name: 'Queue', url: '/billing-admin/billing-admin-queue', icon: 'fas fa-question-circle' },
      // { name: 'Billing Report', url: '/miscellaneous/report/billing-report', icon: 'fas fa-file-invoice-dollar' },
      // { name: 'Confirmation Report', url: '/miscellaneous/report/confirmation-report', icon: 'fas fa-file-invoice' },
      // { name: 'Worklists', url: '/sign-out/worklist', icon: 'fas fa-building', filterOptions: [] },
    ]
  },
];


export const ClientMenuList: any = [
  {
    name: 'Lab Order',
    url: '/accession',
    icon: 'fas fa-align-center',
    child: [
      {
        name: 'Orders', url: '/accession/orders', icon: 'fas fa-shopping-cart',
        filterOptions: [
          { id: ordersIdTypes.all, name: 'All Orders' },
          { id: ordersIdTypes.pending, name: 'Pending' },
          { id: ordersIdTypes.received, name: 'Received' },
          { id: ordersIdTypes.awaitingResults, name: 'Awaiting Results' },
          { id: ordersIdTypes.hold, name: 'Hold' },
          { id: ordersIdTypes.rejected, name: 'Rejected' },
          { id: ordersIdTypes.deleted, name: 'Deleted' },
          { id: ordersIdTypes.exceptions, name: 'Exceptions' },
        ]
      },
      { name: 'New Order', url: '/lab-order/order/' + 0 + '/' + 0 + '/' + 0 + '/' + false + '/new-order', icon: 'fas fa-cart-plus', filterOptions: [] , action: 'addorder' , orderType:'regular'},
      { name: 'New Order', url: '/lab-order/covid-order/' + 0 + '/new-order', icon: 'fas fa-cart-plus', filterOptions: [] , action: 'addorder',  orderType:'covid'},
      { name: 'Multi Order', url: '/lab-order/multi-order/' + 0 + '/multiple-order', icon: 'fas fa-luggage-cart', filterOptions: [], action: 'multipleorder' },
      { name: 'Reports', url: '/lab-order/lab-order-reports', icon: 'fas fa-file-alt', filterOptions: [] },
      { name: 'Analytics', url: '/analytics/client/4', icon: 'fas fa-chart-bar', action: 'analytics'},
      {
        name: 'Patients', url: '/accession/patients', icon: 'fas fa-users',
        filterOptions: [
          { id: patientsIdTypes.active, name: 'Active' },
          { id: patientsIdTypes.inActive, name: 'Inactive' },
        ]
      },
      { name: 'Physicians', url: '/lab-order/lab-order-physicians', icon: 'fas fa-chalkboard-teacher', filterOptions: [] },
      { name: 'Locations', url: '/lab-order/lab-order-locations', icon: 'fas fa-map-marker-alt', filterOptions: [] },
      {
        name: 'Inventory', url: '/client-services/client-services-inventory', icon: 'fas fa-vial',
        filterOptions: [
          { id: ClientServicesInventory.requests, name: 'Requests' },
        ]
      },
      {
        name: 'Shipping', url: '/accession/shipping', icon: 'fas fa-shipping-fast', action: 'shippingclient',
        filterOptions: [
          { id: accessionShipping.allShipments, name: 'All Shipments' },
          { id: accessionShipping.create, name: 'Create Shipment' },
          { id: accessionShipping.preparing, name: 'Preparing' },
          { id: accessionShipping.ready, name: 'Ready' },
          { id: accessionShipping.shipped, name: 'Shipped' },
          { id: accessionShipping.received, name: 'Received' },
        ]
      },
    ]
  },
];


export const PatientMenuList: any = [
  {
    name: 'Lab Order',
    url: '/accession',
    icon: 'fas fa-align-center',
    child: [
      {
        name: 'Orders', url: '/accession/orders', icon: 'fas fa-shopping-cart',
        filterOptions: [
          { id: ordersIdTypes.all, name: 'All Orders' },
          { id: ordersIdTypes.pending, name: 'Pending' },
          { id: ordersIdTypes.received, name: 'Received' },
          { id: ordersIdTypes.awaitingResults, name: 'Awaiting Results' },
          { id: ordersIdTypes.hold, name: 'Hold' },
          { id: ordersIdTypes.rejected, name: 'Rejected' },
          { id: ordersIdTypes.deleted, name: 'Deleted' },
          { id: ordersIdTypes.exceptions, name: 'Exceptions' },
        ]
      },
      // { name: 'Print Order', url: '/lab-order/print-order', icon: 'fas fa-cart-arrow-down', filterOptions: [] },
      { name: 'Reports', url: '/lab-order/lab-order-reports', icon: 'fas fa-file-alt', filterOptions: [] },
    ]
  },
];
